<!-- Young -->
<template>
  <div class="account-ec">
    <public-bread-crumb :routes="routes"></public-bread-crumb>
    <div class="content-wrap">
      <p class="page-title">{{ title }}</p>
      <div class="from-wrap">
        <a-spin :spinning="formLoading">
          <a-form :form="form" style="width: 100%">
            <a-row>
              <a-col
                style="display: flex; width: 1000px; margin-top: -50px"
                :push="1"
              >
                <div
                  class="select-btn"
                  @click="Fun_selectBtn(1)"
                  :style="{ border: selectBtn == 1 ? '2px solid #5364C7' : '' }"
                >
                  <div>
                    <img :src="codeLogo" style="width: 24px; height: 24px" />
                    陕西一码通
                  </div>
                  <img
                    :src="selectPng"
                    class="select-logo"
                    v-show="selectBtn == 1"
                  />
                </div>
                <div
                  class="select-btn"
                  @click="Fun_selectBtn(5)"
                  :style="{ border: selectBtn == 5 ? '2px solid #5364C7' : '' }"
                >
                  <div>西安纳管</div>
                  <img
                    :src="selectPng"
                    class="select-logo"
                    v-show="selectBtn == 5"
                  />
                </div>
                <div
                  class="select-btn"
                  @click="Fun_selectBtn(4)"
                  :style="{ border: selectBtn == 4 ? '2px solid #5364C7' : '' }"
                >
                  <div>宝鸡纳管</div>
                  <img
                    :src="selectPng"
                    class="select-logo"
                    v-show="selectBtn == 4"
                  />
                </div>
              </a-col>
            </a-row>
            <!-- 陕西一码通 -->
            <div class="onecode-item">
              <a-row style="margin-top: 30px">
                <a-col :span="10">
                  <a-form-item
                    label="行政区域"
                    :labelCol="{ span: 10 }"
                    :wrapperCol="{ span: 14 }"
                    required
                  >
                    <a-select
                      placeholder="请选择行政区域"
                      v-decorator="[
                        'areaCode',
                        {
                          rules: [
                            { required: true, message: '请选择行政区域' },
                          ],
                        },
                      ]"
                    >
                      <a-select-option
                        :value="i.id"
                        v-for="i in areaCodeData"
                        :key="i.id"
                      >
                        {{ i.name }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="10">
                  <a-form-item
                    label="区域类型"
                    :labelCol="{ span: 10 }"
                    :wrapperCol="{ span: 14 }"
                    required
                  >
                    <a-select
                      v-decorator="[
                        'regionType',
                        {
                          rules: [
                            { required: true, message: '请选择区域类型' },
                          ],
                        },
                      ]"
                      placeholder="请选择区域类型"
                    >
                      <a-select-option
                        :value="i.code"
                        v-for="i in regionTypeData"
                        :key="i.code"
                      >
                        {{ i.name }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="10">
                  <a-form-item
                    label="型号"
                    :labelCol="{ span: 10 }"
                    :wrapperCol="{ span: 14 }"
                    required
                  >
                    <a-input
                      placeholder="请输入型号"
                      v-decorator="[
                        'deviceModel',
                        {
                          initialValue: '',
                          rules: [
                            {
                              required: true,
                              validator: CheckDeviceModel,
                            },
                          ],
                        },
                      ]"
                    />
                  </a-form-item>
                </a-col>
                <a-col :span="10">
                  <a-form-item
                    label="一码通地点码"
                    :labelCol="{ span: 10 }"
                    :wrapperCol="{ span: 14 }"
                    required
                  >
                    <a-input
                      placeholder="请选择一码通地点码"
                      v-decorator="[
                        'locationCode',
                        {
                          rules: [
                            { required: false, validator: CheckLocationCode },
                          ],
                        },
                      ]"
                    />
                  </a-form-item>
                </a-col>
                <a-col :span="10">
                  <a-form-item
                    label="地址"
                    :labelCol="{ span: 10 }"
                    :wrapperCol="{ span: 14 }"
                    required
                  >
                    <a-input
                      placeholder="请输入地址"
                      v-decorator="[
                        'address',
                        {
                          rules: [
                            {
                              required: true,
                              validator: Checkaddress,
                            },
                          ],
                        },
                      ]"
                    />
                  </a-form-item>
                </a-col>
                <a-col :span="10" v-show="selectBtn != 1">
                  <a-form-item
                    label="场景路由"
                    :labelCol="{ span: 10 }"
                    :wrapperCol="{ span: 14 }"
                    :required="requiredFlag"
                  >
                    <a-select
                      v-decorator="[
                        'scenes',
                        {
                          rules: [
                            {
                              required: requiredFlag,
                              message: '请选择场景路由',
                            },
                          ],
                        },
                      ]"
                      placeholder="请选择场景路由"
                      allowClear
                    >
                      <a-select-option
                        :value="i.id"
                        v-for="i in scenesData"
                        :key="i.id"
                      >
                        {{ i.name }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="10" v-show="selectBtn != 1">
                  <a-form-item
                    label="密钥"
                    :labelCol="{ span: 10 }"
                    :wrapperCol="{ span: 14 }"
                    :required="requiredFlag"
                  >
                    <a-input
                      placeholder="请输入密钥"
                      allowClear
                      v-decorator="[
                        'doorSecret',
                        {
                          rules: [
                            { required: requiredFlag, message: '请输入密钥' },
                          ],
                        },
                      ]"
                    />
                  </a-form-item>
                </a-col>
              </a-row>
            </div>
            <div>
              <a-col :span="24">
                <div class="btn-wrap">
                  <a-button
                    type="primary"
                    class="tool-btn"
                    style="margin-right: 32px"
                    @click="handleSubmit"
                    :loading="btnLoading"
                    >保存</a-button
                  >
                  <a-button
                    class="tool-btn"
                    style="color: #5862cb; background: #ecedff"
                    @click="$router.push('/handle-control')"
                    >取消</a-button
                  >
                </div>
              </a-col>
            </div>
          </a-form>
        </a-spin>
      </div>
    </div>
  </div>
</template>

    <script>
import HandleServices from "@/services/accessControl.services";
import selectPng from "./assets/select.png";
import codeLogo from "./assets/code.png";
import {
  PubCheckName,
  PubCheckPwd,
  PubCheckAddress,
  PubCheckDeviceModel,
  PubCheckLocationCode,
} from "@/utils/utils";
export default {
  name: "HandleEC",
  inject: ["reload"],
  data() {
    return {
      scenesStr: "",
      doorSecretStr: "",
      requiredFlag: true,
      regionTypeData: [], // 区域类型
      scenesData: [], // 场景类型
      areaCodeData: [], // 行政区域

      title: "一码通设置",
      modalArr: {},
      showModal: false,
      treeData: [],
      treeAreaData: [],
      regionTypeData: [],
      scenesData: [], //场景路由
      btnLoading: false,
      selectPng,
      codeLogo,
      selectBtn: 1,
      form: this.$form.createForm(this, { name: "AccessForm" }),
      pwdReg: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/,
      id: "",
      formLoading: false,
      oldUserPhone: "",
      formFields: [
        "areaCode",
        "regionType",
        "deviceModel",
        "locationCode",
        "address",
        "scenes",
        "doorSecret",
      ],
    };
  },
  computed: {
    // 监听属性 类似于data概念
    routes() {
      return [
        {
          name: "手持设备管理",
          path: "/handle-control",
        },
        {
          name: this.title,
          path: "",
        },
      ];
    },
  },
  async mounted() {
    this.getAreaCodeList();
    this.getRegionTypeList();
    this.getscenesList();
    /*
          编辑模式
          >>根据传入的ID,调接口获得表单的数据
          >>通过setFieldsValue({控件的id名: 控件对应的表单数据}),回填数据
          >>例子：this.formData.setFieldsValue({userName: '张三'})
        */
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
      this.getInfo();
    }
  },
  methods: {
    Checknull(rule, value, callback) {
      callback();
    },
    // 获取行政区域列表
    async getAreaCodeList() {
      const { status, result } = await HandleServices.GetAreaCode();
      if (status === 0) {
        this.areaCodeData = result;
      }
      // this.areaCodeData = [
      //   { id: "610102", name: "陕西省西安市新城区" },
      //   { id: "610103", name: "陕西省西安市碑林区" },
      //   { id: "610104", name: "陕西省西安市莲湖区" },
      //   { id: "610111", name: "陕西省西安市灞桥区" },
      //   { id: "610112", name: "陕西省西安市未央区" },
      //   { id: "610113", name: "陕西省西安市雁塔区" },
      //   { id: "610114", name: "陕西省西安市阎良区" },
      //   { id: "610115", name: "陕西省西安市临潼区" },
      //   { id: "610116", name: "陕西省西安市长安区" },
      //   { id: "610117", name: "陕西省西安市高陵区" },
      //   { id: "610118", name: "陕西省西安市鄠邑区" },
      //   { id: "610122", name: "陕西省西安市蓝田县" },
      //   { id: "610124", name: "陕西省西安市周至县" },
      //   { id: "610130", name: "陕西省西安市西咸新区" },
      //   { id: "610131", name: "陕西省西安市国际港务区" },
      //   { id: "610132", name: "陕西省西安市高新区" },
      //   { id: "612222", name: "陕西省测试区" },
      // ];
    },
    // 获取区域类型列表
    async getRegionTypeList() {
      const { status, result } = await HandleServices.GetRegionType();
      if (status === 0) {
        this.regionTypeData = result;
      }
      // this.regionTypeData = [
      //   { code: 1, name: "地铁站" },
      //   { code: 2, name: "机场" },
      //   { code: 3, name: "汽车站" },
      //   { code: 4, name: "商业体" },
      //   { code: 5, name: "小区" },
      //   { code: 6, name: "电影院" },
      //   { code: 7, name: "酒店" },
      //   { code: 8, name: "市场商户摊贩" },
      //   { code: 9, name: "景区" },
      //   { code: 10, name: "商用写字楼" },
      //   { code: 11, name: "医院" },
      //   { code: 12, name: "学校" },
      //   { code: 13, name: "超市" },
      //   { code: 14, name: "商场" },
      //   { code: 15, name: "综合市场" },
      //   { code: 16, name: "市场商户电子秤" },
      //   { code: 17, name: "企业" },
      //   { code: 18, name: "其他" },
      // ];
    },
    // 获取场景类型列表
    async getscenesList() {
            const { status, result } = await HandleServices.GetScenes();
      if (status === 0) {
        this.scenesData = result;
      }
      // this.scenesData = [
      //   { id: "bgsccs", name: "办公生产场所" },
      //   { id: "blg", name: "宾旅馆" },
      //   { id: "cyfwcs", name: "餐饮服务场所" },
      //   { id: "dxhzg", name: "大型会展馆" },
      //   { id: "ggjtcs", name: "公共交通场所" },
      //   { id: "ggsydw", name: "公共事业单位" },
      //   { id: "jgsydw", name: "机关事业单位" },
      //   { id: "jmxq", name: "居民小区" },
      //   { id: "jrfwcs", name: "金融服务场所" },
      //   { id: "jsgd", name: "建设工地" },
      //   { id: "jtkk", name: "交通卡口" },
      //   { id: "jyfwcs", name: "教育服务场所" },
      //   { id: "syfwcs", name: "商业服务场所" },
      //   { id: "whlycs", name: "文化旅游场所" },
      //   { id: "wlwd", name: "物流网点" },
      //   { id: "yclz", name: "一场两站" },
      //   { id: "ylfwcs", name: "医疗服务场所" },
      //   { id: "ylhjzfwcs", name: "养老和救助服务场所" },
      //   { id: "zjcs", name: "宗教场所" },
      // ];
    },
    // 密码校验
    CheckPwd(rule, value, callback) {
      PubCheckPwd(rule, value, callback);
    },
    //手持机名字校验
    CheckName(rule, value, callback) {
      PubCheckName(rule, value, callback);
    },
    //一码通地点码校验
    CheckLocationCode(rule, value, callback) {
      PubCheckLocationCode(rule, value, callback);
    },
    //地址校验
    Checkaddress(rule, value, callback) {
      PubCheckAddress(rule, value, callback);
    },
    //型号校验
    CheckDeviceModel(rule, value, callback) {
      PubCheckDeviceModel(rule, value, callback);
    },

    // 选中一码通btn
    Fun_selectBtn(num) {
      //   let scenes = this.form.getFieldValue("scenes");
      //   let doorSecret = this.form.getFieldValue("doorSecret");
      this.selectBtn = num;
      //   if (this.selectBtn == 1) {
      // this.requiredFlag = false;

      // this.form.setFields({
      //   scenes: { errors: false },
      //   doorSecret: { errors: false },
      // });
      // this.form.setFields({
      //   scenes: { value: scenes },
      //   doorSecret: { value: doorSecret },
      // });
      //   } else {
      // this.requiredFlag = true;
      //   }
    },

    // 获取当前设备详细数据
    async getInfo() {
      this.formLoading = true;
      let res = await HandleServices.GetHandheldEquInfo({ id: this.id });
      this.formLoading = false;
      if (res.status === 0) {
        this.scenesStr = res.result.scenes;
        this.doorSecretStr = res.result.doorSecret;
        this.selectBtn = res.result.type;
        this.form.setFieldsValue({
          areaCode: res.result.areaCode,
          regionType: res.result.regionType,
          deviceModel: res.result.deviceModel,
          locationCode: res.result.locationCode,
          address: res.result.address,
          scenes: res.result.scenes,
          doorSecret: res.result.doorSecret,
        });
      }
    },

    /**
     * 提交表单
     */
    handleSubmit() {
      this.CheckAll();
    },

    async CheckAll() {
      let checkFlag = false;
      let healthStr = {};

      if (this.selectBtn == 1) {
        this.form.validateFields(
          ["areaCode", "regionType", "deviceModel", "locationCode", "address"],
          async (err, values) => {
            if (!err) {
              checkFlag = true;
              this.btnLoading = true;
              healthStr = {
                sn: this.id,
                areaCode: values.areaCode,
                regionType: values.regionType,
                deviceModel: values.deviceModel,
                address: values.address,
                locationCode: values.locationCode,
                doorSecret: this.doorSecretStr,
                scenes: this.scenesStr,
                type: this.selectBtn,
                name: "",
              };
            }
          }
        );
      } else {
        this.form.validateFields(async (err, values) => {
          if (!err) {
            checkFlag = true;
            this.btnLoading = true;
            healthStr = {
              sn: this.id,
              areaCode: values.areaCode,
              regionType: values.regionType,
              deviceModel: values.deviceModel,
              address: values.address,
              locationCode: values.locationCode,
              doorSecret: values.doorSecret,
              scenes: values.scenes,
              type: this.selectBtn,
              name: "",
            };
          }
        });
      }
      if (checkFlag) {
        const { status, result } = await HandleServices.UpdateHandheldEqu(
          healthStr
        );
        if (status === 0) {
          let desc = "";
          if (this.id) {
            desc = result;
          }
          this.notification("success", "成功", desc);
          this.$router.push("/handle-control");
        }
      }
      this.btnLoading = false;
    },
  },
};
</script>
    <style lang='less' scoped>
// @import url(); 引入公共css类
.account-ec {
  width: 100%;
  min-height: 800px;
  margin: 0 auto;
  background: rgba(255, 255, 255, 1);
  border-radius: 10px;
  .content-wrap {
    height: 540px;
    margin: 0 16px 16px;
    padding: 24px;
    background: #ffffff;
    display: flex;
    flex-direction: column;
    .page-title {
      font-size: 18px;
      color: #5862cb;
      // margin-bottom: 140px !important;
    }
    .from-wrap {
      padding: 120px 12%;
      flex: 1;
      // display: flex;
      // align-items: center;
      // justify-content: center;

      .onecode-item {
        min-height: 300px;
      }

      .select-btn {
        padding: 16px;
        height: 56px;
        border: 2px solid #dadfe6;
        text-align: center;
        margin-left: 24px;
        border-radius: 6px 6px 6px 6px;
        cursor: pointer;
        font-size: 16px;
        font-family: Roboto-Regular, Roboto;
        font-weight: 400;
        position: relative;
        overflow: hidden;

        .select-logo {
          width: 28px;
          height: 27px;
          position: absolute;
          right: 0;
          top: 27px;
        }
      }
      .item-input {
        max-width: 296px;
        // margin-left: 10px;
      }
      .btn-wrap {
        display: flex;
        justify-content: center;
        align-items: center;
        .tool-btn {
          width: 88px;
          height: 32px;
          border-radius: 3px;
        }
      }
    }
  }
}
</style>
